const gameAutoMessages = (state = {}, {type, payload}) => {
  const updateGameAutoMessage = payload => {
    const messages = state.gameAutoMessages
    const index = messages.findIndex((m => m.id == payload.id))
    messages[index] = payload

    return messages
  }

  const deleteGameAutoMessage = payload => {
    const messages   = state.gameAutoMessages.filter((m) => m.id != payload)
    const totalCount = state.totalCount - 1

    return {gameAutoMessages: messages, totalCount: totalCount}
  }

  switch (type) {
    case 'GAME_AUTO_MESSAGES.INIT':
      return {...state, ...payload, locations: state.locations || []}
    case 'GAME_AUTO_MESSAGES.RECEIVED':
      return {...state, ...payload}
    case 'GAME_AUTO_MESSAGES.LOCATIONS_RECEIVED':
      return {...state, ...payload}
    case 'GAME_AUTO_MESSAGES.UPDATED':
      return {...state, ...updateGameAutoMessage(payload)}
    default:
      return state
  }
}

export default gameAutoMessages
